import { isPositiveNumber } from "et3-type-guards";

export let timeOutKeys: {
  [key: string]: NodeJS.Timer[];
} = {};
export const delay = async (ms: number, timeOutKey: string) =>
  new Promise((resolve) => {
    const timeOutId = setTimeout(resolve, ms);
    if (timeOutKey in timeOutKeys) {
      timeOutKeys[timeOutKey].push(timeOutId);
    } else {
      timeOutKeys[timeOutKey] = [timeOutId];
    }
  });
export const clearDelay = (timeOutKey: string) => {
  if (timeOutKey in timeOutKeys) {
    for (const timeOutId of timeOutKeys[timeOutKey]) {
      if (isPositiveNumber(timeOutId)) {
        clearTimeout(timeOutId);
      }
    }
  }
};
